import type { ClampQcWorkOrderBundle } from "./clampQcMockData";

/** Matches `registerClampQcInspectionExistsRoutes` when `exists: true`. */
export type ClampQcExistingInspectionDetails = {
  trimmedSerial: string;
  recordedForBuildOrderId: number | null;
  recordedWorkOrderLabel: string | null;
  recordedPurchaseOrderNumber: string | null;
  sgsQcAtIso: string | null;
  sku: string | null;
  inspectionResult: "Passed" | "Failed" | null;
};

export function clampQcDuplicateSerialOnOpenJob(
  existing: Pick<ClampQcExistingInspectionDetails, "recordedForBuildOrderId">,
  bundle: Pick<ClampQcWorkOrderBundle, "buildOrderId">,
): boolean {
  return (
    existing.recordedForBuildOrderId != null && existing.recordedForBuildOrderId === bundle.buildOrderId
  );
}

export function clampQcDuplicateSerialIncidentIssue(existing: ClampQcExistingInspectionDetails): string {
  const workOrder =
    existing.recordedWorkOrderLabel != null && existing.recordedWorkOrderLabel.trim() !== ""
      ? existing.recordedWorkOrderLabel.trim()
      : existing.recordedForBuildOrderId != null
        ? `build order ${String(existing.recordedForBuildOrderId)}`
        : "another job";
  const purchaseOrder =
    existing.recordedPurchaseOrderNumber != null && existing.recordedPurchaseOrderNumber.trim() !== ""
      ? ` (${existing.recordedPurchaseOrderNumber.trim()})`
      : "";
  const result =
    existing.inspectionResult != null ? ` Result: ${existing.inspectionResult}.` : "";
  return `Duplicate clamp serial ${existing.trimmedSerial} scanned at QC. Previously inspected on ${workOrder}${purchaseOrder}.${result}`;
}

export function clampQcDuplicateSerialIncidentNotes(
  existing: ClampQcExistingInspectionDetails,
  openBundle: ClampQcWorkOrderBundle,
): string {
  const lines = [
    `Open job: ${openBundle.context.workOrder} (build order ${String(openBundle.buildOrderId)}).`,
    `Purchase order on open job: ${openBundle.context.purchaseOrder}.`,
  ];
  if (existing.sgsQcAtIso != null) {
    lines.push(`Previous QC recorded at: ${existing.sgsQcAtIso}.`);
  }
  if (existing.sku != null && existing.sku.trim() !== "") {
    lines.push(`Stock keeping unit on previous row: ${existing.sku.trim()}.`);
  }
  return lines.join(" ");
}
